import { EventEngineStateEntity } from "@hds-products/event-runtime-entities-common";
import { FrankServiceEntityPersistence } from "@hds/entity-lib";

class EventEngineStateClientEntity extends EventEngineStateEntity {
    constructor(ep, seedData = {}, options = {}) {
        super(ep, seedData, options);
    }
    static createInstance(baseUri, seedData, customHeaderFn) {
        const ep = EventEngineStateClientEntity.createEntityPersistence(baseUri, customHeaderFn);
        return new EventEngineStateClientEntity(ep, seedData);
    }
    static createEntityPersistence(baseUri, customHeaderFn) {
        const ep = new FrankServiceEntityPersistence(baseUri, EventEngineStateClientEntity.prototype._meta.entityName, customHeaderFn);
        return ep;
    }
    /*****************************************************/
    // START OVERRIDDEN PROPERTIES
    /*****************************************************/
    set eventType(newEventType) {
        throw new Error('SET_PROPERTY_NOT_ALLOWED');
    }
    set eventTypeBiddingRules(newEventTypeBiddingRules) {
        throw new Error('SET_PROPERTY_NOT_ALLOWED');
    }
    set runList(newRunList) {
        throw new Error('SET_PROPERTY_NOT_ALLOWED');
    }
    /*****************************************************/
    // END OVERRIDDEN PROPERTIES
    // START OVERRIDDEN METHODS
    /*****************************************************/
    create() { throw new Error('METHOD_NOT_ALLOWED'); }
    upsert() { throw new Error('METHOD_NOT_ALLOWED'); }
    update() { throw new Error('METHOD_NOT_ALLOWED'); }
    patch() { throw new Error('METHOD_NOT_ALLOWED'); }
    replace() { throw new Error('METHOD_NOT_ALLOWED'); }
    delete() { throw new Error('METHOD_NOT_ALLOWED'); }
    /*****************************************************/
    // END OVERRIDDEN METHODS
    /*****************************************************/
}

export { EventEngineStateClientEntity };
export default EventEngineStateClientEntity;